import styled from 'styled-components';
import { breakpoint } from '@sketch/global-styles';
import { Text, Grid } from '@sketch/components';

const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const Title = styled.h1 `
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.H};
`;
const SubTitle = styled(Text).attrs({
    textStyle: 'copy.tertiary.standard.F',
}) `
  margin: 8px 0 40px 0;
`;
const StyledGrid = styled(Grid) `
  max-width: 1400px;
  margin-top: 40px;
`;
const Separator = styled.hr `
  margin: 0;
  border-color: ${({ theme }) => theme.colors.border.A};

  /* Makes the divider full width*/
  margin-left: -40px;
  margin-right: -40px;

  ${breakpoint('base', 'sm') `
    margin-left: -16px;
    margin-right: -16px;
  `}
`;

export { Separator, StyledGrid, SubTitle, Title, Wrapper };
